<div class="auth-sign-up__body">
  <div class="auth-sign-up__form">
    <div  [ngClass]="{'hidden': !!isMobile}">
      <div class="auth-sign-up__about">
        <h1 class="auth-sign-up__title" [innerHTML]="title"></h1>
        <h4 *ngIf="desc" class="auth-sign-up__desc mt6" [innerHTML]="desc"></h4>

        <ul class="auth-sign-up__listing mt20 mb60">
          <li *ngFor="let step of steps">
            <i class="db-icon db-icon-ds-checkmark-small mr8"></i>
              <p>{{step}}</p>
          </li>
        </ul>
        <div class="auth-sign-up__about-icons">
          <div class="auth-sign-up__about-images">
            <img src="assets/images/logos/services/g2_FI_2020.svg" alt=""/>
            <img src="assets/images/logos/services/g2_HP_2021.svg" alt=""/>
          </div>
          <db-trustpilot></db-trustpilot>
        </div>
      </div>

    </div>
    <div class="create-ai-assistant-form-view__form-div">
      <h1 class="auth-sign-up__title" *ngIf="!!isMobile" [innerHTML]="title"></h1>
      <h4 class="auth-sign-up__desc mt5" *ngIf="!!isMobile && !!desc" [innerHTML]="desc"></h4>
      <form [formGroup]="signUpForm" class="create-ai-assistant-form-view__form">
        <div class="auth-sign-up__form-inputs">
          <div>
            <div class="db-google-block mt24" *ngIf="companyInfo?.branding?.google_client_id">
              <db-google-auth (verifyGoogleToken)="signUpWithGoogle($event)" [loading]="googleBtnLoading"
              [googleClientId]="companyInfo?.branding?.google_client_id"></db-google-auth>
            </div>
            <div class="db-google-divider" *ngIf="companyInfo?.branding?.google_client_id">
              <span>or</span>
            </div>

            <div class="ds-input-wrap mb9">
              <input type="email" maxlength="100" name="email"  formControlName="email" [style.border-color]="(emailChecked && !userDoesNotExist) || (signUpForm.controls['email'].invalid && ((signUpForm.controls['email'].touched && !signUpForm.controls['email'].errors['required']) || formSubmitted)) || (serverErrors && serverErrors.fields.email) ? '#D41125' : null" (blur)="blurEmail()" class="ds-input sl-sign_up_email_field" [placeholder]="'text_createProfileEmail' | dbText">
              <span class="ds-input-error-msg" *ngIf="signUpForm.controls['email'].invalid && ((signUpForm.controls['email'].touched && !signUpForm.controls['email'].errors['required']) || formSubmitted) && !serverErrors">{{signUpForm.controls['email'].value.length ? ('text_invalidEmail' | dbText) : ('text_requiredEmail' | dbText)}}</span>
              <span class="ds-input-error-msg" *ngIf="signUpForm.controls['email'].valid && emailChecked && !userDoesNotExist || (serverErrors && serverErrors.fields.email)">{{'text_existEmail' | dbText}}</span>
            </div>

            <div class="auth-sign-up__group auth-sign-up__flname">
              <div class="ds-input-wrap mb9">
                <input type="text" name="fname" maxlength="60" formControlName="firstName" [style.border-color]="(signUpForm.controls['firstName'].invalid && ((signUpForm.controls['firstName'].touched && !signUpForm.controls['firstName'].errors['required']) || formSubmitted)) || (serverErrors && serverErrors?.fields?.first_name) ? '#D41125' : null" class="ds-input" [placeholder]="'text_accountSettingsFirstName' | dbText">
                <span class="ds-input-error-msg"
                      *ngIf="(signUpForm.controls['firstName'].invalid && ((signUpForm.controls['firstName'].touched && !signUpForm.controls['firstName'].errors['required']) || formSubmitted)) || (serverErrors && serverErrors?.fields?.first_name)">
                {{serverErrors && serverErrors?.fields.first_name ? serverErrors.fields?.first_name : (signUpForm.controls['firstName'].errors?.link ? ('text_invalidFirstName' | dbText) : ('text_requiredFirstName' | dbText))}}
              </span>
              </div>

              <div class="ds-input-wrap mb9">
                <input type="text" name="lname" maxlength="60" formControlName="lastName" [style.border-color]="(signUpForm.controls['lastName'].invalid && ((signUpForm.controls['lastName'].touched && !signUpForm.controls['lastName'].errors['required']) || formSubmitted)) || (serverErrors && serverErrors?.fields?.last_name) ? '#D41125' : null" class="ds-input" [placeholder]="'text_accountSettingsLastName' | dbText">
                <span class="ds-input-error-msg"
                      *ngIf="signUpForm.controls['lastName'].invalid && ((signUpForm.controls['lastName'].touched && !signUpForm.controls['lastName'].errors['required']) || formSubmitted) || (serverErrors && serverErrors?.fields?.last_name)">
                {{serverErrors && serverErrors?.fields.last_name ? serverErrors.fields?.last_name : (signUpForm.controls['lastName'].errors?.link ? ('text_invalidLastName' | dbText) : ('text_requiredLastName' | dbText))}}
              </span>
              </div>
            </div>

            <div class="ds-input-wrap mb9">
              <div class="ds-input-password-wrap">
                <input #password type="password" class="ds-input" placeholder="password"  name="password" formControlName="password"
                       (focus)="showPWDRequirements = true" (focusout)="showPWDRequirements = false"
                       (ngModelChange)="progressPercent()"
                       [placeholder]="'text_createProfilePassword' | dbText"
                       [style.border-color]="(signUpForm.controls['password'].invalid && ((signUpForm.controls['password'].touched && !signUpForm.controls['password'].errors['required']) || formSubmitted)) ? '#D41125' : null">
                <a class="ds-input-password-trigger" (click)="password.type = password.type === 'text' ? 'password' : 'text'; password.focus()">
                  <i class="db-icon {{password.type === 'text' ? 'db-icon-ds-eye' : 'db-icon-ds-eye-cancel'}}"></i>
                </a>
              </div>
              <span class="ds-input-error-msg"  *ngIf="(signUpForm.controls['password'].invalid && ((signUpForm.controls['password'].touched && !signUpForm.controls['password'].errors['required']) || formSubmitted) ) || (serverErrors && serverErrors.fields['password'])">{{serverErrors?.fields?.password || ('text_requiredPassword1' | dbText)}}</span>
              <db-password-validation [formGroup]="signUpForm" *ngIf="showPWDRequirements"></db-password-validation>
            </div>

          </div>
        </div>
      </form>

      <div>
        <button class="ds-btn-black rectangle"
                [ngClass]="{'ds-btn-disabled': !!loading, 'ds-btn-xl': !isMobile, 'ds-btn-l': isMobile}"
                (click)="onSignUpSubmit()">
          <span *ngIf="!loading">{{['ai-demo', 'builder-v2'].includes(answersData?.LastChosenOption) ? 'Sign Up and Preview Your Website' : 'Sign Up' }}</span>
          <db-loading-circular-spinner *ngIf="!!loading"></db-loading-circular-spinner>
        </button>

        <div class="auth-sign-up__have-account mt15">
          <p>By signing up, you agree to 10Web’s <a href="https://10web.io/terms-of-service" target="_blank" rel="noopener" class="ds-link">Terms of Service</a><br *ngIf="!isMobile"/>  and <a class="sign-up confirm-terms ds-link" href="https://10web.io/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.</p>
        </div>

      </div>
    </div>
  </div>
</div>
